import * as ChatActions from 'llm/chat-library/ChatActions';
import {openChat} from 'llm/chat-library/sidepanel/ChatRouterUtil';
import {getChatTypeForNewAgentChat, getDefaultAgentType} from 'llm/chat-library/sidepanel/ChatTypeUtil';
import type {ChatUseCase} from 'llm/chat-library/use-cases/chatUseCaseCatalog';
import recordChatUseCaseRun from 'llm/chat-library/use-cases/recordChatUseCaseRun';
import notifications from 'notifications';

/**
 * Start a new chat with the use case's prompt already submitted, record the run, and open the chat.
 *
 * Use case prompts are written to be sent as-is ("Ask me one or two questions…"), so this submits
 * rather than pre-filling a draft. Opening the chat also closes the chat settings modal, since
 * `openChat` clears the modal state.
 */
export default async function runChatUseCase(
  chatUseCase: ChatUseCase,
  {categoryId}: {categoryId: string}
): Promise<void> {
  const agentType = getDefaultAgentType();
  if (agentType == null) {
    notifications.warn('You do not have access to chat. Contact your administrator.');
    return;
  }

  const chatType = getChatTypeForNewAgentChat(agentType);
  const {chatSessionId} = await ChatActions.createChat(chatType, {}, agentType);
  ChatActions.setDraftMessage(chatSessionId, {
    status: ChatActions.ChatDraftStatus.DRAFT,
    message: {text: chatUseCase.prompt, selectedFiles: []},
    settings: {agentType, publicDataEnabled: false},
  });
  ChatActions.submitDraftMessage(chatSessionId, {analytics: {messageCount: 0}});
  recordChatUseCaseRun(chatUseCase.id, {categoryId, source: 'use_cases_tab'});
  openChat(chatSessionId);
}
